import axios, { CancelTokenSource } from 'axios';
import { EXTERNAL_STATUS_HTTP_TIMEOUT, HttpRequestOptions } from './BaseApi';

export default class LatestRequest {
  private source?: CancelTokenSource;
  private version = 0;
  public begin(): { version: number; options: HttpRequestOptions } {
    this.cancel(); this.source = axios.CancelToken.source();
    return { version: this.version, options: { timeoutMs: EXTERNAL_STATUS_HTTP_TIMEOUT, cancelToken: this.source.token } };
  }
  public isLatest(version: number): boolean { return version === this.version; }
  public cancel(): void { this.version += 1; if (this.source) this.source.cancel(); this.source = undefined; }
  public static isCancelled(error: any): boolean { return axios.isCancel(error); }
  public static isTimeout(error: any): boolean { return error && error.code === 'ECONNABORTED'; }
  public static isExternalUnavailable(error: any): boolean {
    const status = error && error.status;
    const responseStatus = error && error.response && error.response.status;
    return this.isTimeout(error) ||
      status === 0 || status === 502 || status === 504 ||
      responseStatus === 0 || responseStatus === 502 || responseStatus === 504;
  }
}
